module["exports"] = [
  "#{city_name}"
];
